export default {
  "version": "{{VERSION}}",
  "search": {
    "quickLinks": {
      "defaultValue": [
        {
          "text": "EXCLUSIVE",
          "link": "/888-exklusive-spiele/"
        },
        {
          "text": "PROMOTIONS",
          "link": "/aktionen/"
        },
        {
          "text": "CASHIER",
          "externalLinkSource": "cashier"
        }
      ]
    },
    "suggestedGames": {
      "defaultValue": [
        130191,
        130043,
        2370000,
        2310404,
        2340099,
        2341097
      ],
      "statements": []
    },
    "suggestedCategories": {
      "defaultSuggestedCategories": {
        "defaultValue": [
          {
            "text": "888 Exclusive",
            "link": "/888-exklusive-spiele/"
          },
          {
            "text": "Promotions",
            "link": "/aktionen/"
          },
          {
            "text": "Cashier",
            "externalLinkSource": "cashier"
          }
        ]
      },
      "suggestedCategoriesOptions": {
        "defaultValue": []
      }
    }
  },
  "ClockAndLastLoginBox": {
    "lastLoginDisplay": {
      "defaultValue": false,
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            }
          ],
          "value": true
        }
      ]
    },
    "display": true
  },
  "header": {
    "gambling_message": {
      "display": false
    },
    "responsibleIcons": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": true
          }
        ]
      }
    },
    "header_buttons": {
      "safezoneButton": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "deviceType",
                  "operator": "equal",
                  "value": "mobile"
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": false
                }
              ],
              "value": false
            }
          ]
        }
      }
    },
    "cross_brand": {
      "display": false,
      "sites": [
        {

        }
      ]
    }
  },
  "sideMenu": {
    "menu_links": {
      "signUp": {
        "text": "SIGN_UP",
        "link": "membership",
        "class": "signup",
        "dl": "19518",
        "isExternalLink": true,
        "display": {
          "defaultValue": false,
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": false
                },
                {
                  "id": "deviceType",
                  "operator": "equal",
                  "value": "mobile"
                }
              ],
              "value": true
            }
          ]
        }
      },
      "home": {
        "text": "HOME",
        "link": "/",
        "class": "home",
        "tabState": "_self",
        "isExternalLink": false,
        "display": true
      },
      "slots": {
        "text": "SLOTS",
        "link": "/spielautomaten/",
        "class": "slots",
        "tabState": "_self",
        "isExternalLink": false,
        "display": true
      },
      "newGames": {
        "text": "INFO_TITLE_ARENA_NEW_GAMES",
        "link": "/new-games/",
        "class": "new-games",
        "tabState": "_self",
        "isExternalLink": false,
        "display": true
      },
      "exclusive888arena": {
        "text": "EXCLUSIVE",
        "link": "/888-exklusive-spiele/",
        "class": "exclusive888games",
        "tabState": "_self",
        "isExternalLink": false,
        "display": true
      },
      "deposit": {
        "text": "DEPOSIT_SIDE_MENU",
        "link": "cashier",
        "class": "deposit",
        "isExternalLink": true,
        "display": {
          "defaultValue": false,
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "deviceType",
                  "operator": "equal",
                  "value": "mobile"
                }
              ],
              "value": true
            },
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": true
            }
          ]
        }
      },
      "promotions": {
        "text": "PROMOTIONS",
        "link": "/aktionen/",
        "class": "promotions",
        "tabState": "_self",
        "isExternalLink": false,
        "display": true
      },
      "liveChat": {
        "text": "LIVE_CHAT",
        "target": "window",
        "externalLinkSource": "live_chat",
        "class": "live-chat",
        "isExternalLink": true,
        "display": false
      },
      "blog": {
        "text": "BLOG",
        "link": "/blog/",
        "class": "blog",
        "tabState": "_blank",
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        }
      },
      "gamingHistory": {
        "text": "GAMING_HISTORY",
        "display": true,
        "link": "/gaming-history/",
        "isExternalLink": false,
        "tabState": "_self",
        "class": "gaming-history"
      },
      "cashierHistory": {
        "text": "CASHIER_HISTORY",
        "display": true,
        "externalLinkSource": "cashier",
        "options": { "sessionType": 2 },
        "isExternalLink": true,
        "tabState": "_self",
        "class": "cashier",
        "link": "cashier"
      }
    },
    "menuLinksBlockOrder": {
      "defaultValue": [
        [ "signUp" ],
        [ "promotions" ],
        [ "home", "slots", "newGames", "exclusive888arena" ],
        [ "blog" ],
        [ "liveChat" ]
      ]
    },
    "stickyMenuBlockOrder": {
      "defaultValue": [ [ "home", "slots", "exclusive888arena", "promotions", "deposit" ] ]
    },
    "brand_sites": {
      "sites": [],
      "display": {
        "defaultValue": false
      }
    },
    "store_button": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              },
              {
                "id": "isHybrid",
                "operator": "equal",
                "value": false
              },
              {
                "condition": "OR",
                "rules": [
                  {
                    "id": "countryCode",
                    "operator": "equal",
                    "value": "dan"
                  }
                ]
              }
            ],
            "value": true
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              },
              {
                "id": "isHybrid",
                "operator": "equal",
                "value": false
              },
              {
                "condition": "OR",
                "rules": [
                  {
                    "id": "countryCode",
                    "operator": "equal",
                    "value": "gbr"
                  }
                ]
              }
            ],
            "value": false
          }
        ]
      },
      "imgSrcFallback": {
        "defaultValue": "",
        "statements": [
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              }
            ],
            "value": "{assetsPath}/images/store/store-button-ios-eng.svg"
          },
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              }
            ],
            "value": "{assetsPath}/images/store/store-button-android-eng.png"
          }
        ]
      },
      "imgSrc": {
        "defaultValue": "",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              },
              {
                "id": "langCode",
                "operator": "any_of",
                "value": [ "eng", "ger", "swe", "rus", "por", "fre", "spa", "fin", "nor" ]
              }
            ],
            "value": "{assetsPath}/images/store/store-button-ios-{lang}.svg"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              },
              {
                "id": "langCode",
                "operator": "any_of",
                "value": [ "eng", "ger", "swe", "rus", "por", "fre", "spa", "fin", "nor" ]
              }
            ],
            "value": "{assetsPath}/images/store/store-button-android-{lang}.png"
          }
        ]
      },
      "appLink": {
        "defaultValue": "",
        "statements": [
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              }
            ],
            "value": "https://app.appsflyer.com/id998457567"
          },
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              }
            ],
            "value": "https://play.google.com/store/apps/details?id=com.r888.rl"
          }
        ]
      }
    },
    "helpLinkMobile": {
      "display": true
    }
  },
  "drawer": {
    "welcomeMessage": {
      "conditions": [
        {
          "time": "00:00",
          "text": "GREETING_MORNING"
        },
        {
          "time": "12:00",
          "text": "GREETING_AFTERNOON"
        },
        {
          "time": "18:00",
          "text": "GREETING_EVENING"
        },
        {
          "time": "22:00",
          "text": "GREETING_NIGHT"
        }
      ],
      "defaultMessage": "GREETING_DEFAULT",
      "showUserTitle": false,
      "showFirstName": true,
      "showLastName": false
    },
    "usefulLinks": [
      {
        "id": "transactionHistory",
        "text": "TRANSACTION_HISTORY",
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isMiniOrbit",
                  "operator": "=",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "analytics": {
          "label": "Transaction History"
        }
      },
      {
        "id": "helpCenter",
        "text": "HELP_CENTER",
        "target": "window",
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isMiniOrbit",
                  "operator": "=",
                  "value": true
                },
                {
                  "id": "deviceType",
                  "operator": "equal",
                  "value": "mobile"
                }
              ],
              "value": false
            }
          ]
        },
        "analytics": {
          "label": "Help Center"
        }
      }
    ],
    "drawerBoxes": [
      {
        "text": "MY_CLUB",
        "link": "/my_account/",
        "externalLinkSource": "my_account",
        "class": "challenges-box",
        "options": {
          "tabId": 7
        },
        "seo": {
          "category": "Navigation",
          "action": "NavBar",
          "label": "My_Club"
        },
        "display": false
      }
    ],
    "showLoyalty": {
      "analytics": {
        "category": "Navigation",
        "action": "NavBar",
        "label": "Loyalty_Bar"
      },
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              },
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "_IsCIP",
                "operator": "equal",
                "value": true
              }
            ],
            "value": true
          }
        ]
      }
    }
  },
  "gamePopup": {
    "title": "GAME_POPUP_TITLE",
    "subTitle": "GAME_POPUP_SUB_TITLE",
    "descriptionText": "GAME_POPUP_DESCRIPTION",
    "menuLinks": [
      "gamingHistory",
      "cashierHistory"
    ]
  },
  "footer": {
    "componentID": {
      "defaultValue": "494504",
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "isEmbeddedHybrid",
              "operator": "equal",
              "value": true
            }
          ],
          "value": "494506"
        }
      ]
    },
    "templateID": {
      "defaultValue": "392012"
    },
    "fallbackComponent": "defaultFooter"
  },
  "arenas": {
    "slots": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/slots_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "pc"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_pc.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_mobile.png"
          }
        ]
      },
      "title": {
        "defaultValue": "INFO_TITLE_ARENA_VIDEO_SLOTS",
        "statements": []
      },
      "filters": {
        "defaultValue": [
          "vendor_888",
          "vendor_playngo",
          "vendor_merkur",
          "vendor_gamomat",
          "vendor_netent",
          "vendor_redtiger",
          "vendor_pragmatic"
        ],
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "isMobile",
                "operator": "equal",
                "value": true
              }
            ],
            "value": [
              "vendor_888",
              "vendor_netent",
              "vendor_playngo",
              "vendor_pragmatic",
              "vendor_playtech",
              "vendor_redtiger",
              "vendor_merkur",
              "vendor_blueprint",
              "one-to-twenty-five",
              "twenty-five-plus"
            ]
          }
        ]
      },
      "advancedFilters": {
        "categories": [
          {"id": "volatility"},
          { "id": "features" },
          { "id": "themes" },
          { "id": "vendors" }
        ]
      },
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/slots_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_SLOTS",
        "infoText": "INFO_TEXT_ARENA_SLOTS"
      },
      "promotionalBanner": {
        "componentID": "495163",
        "templateID": "392012"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "495175",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": {
          "defaultValue": "495144"
        },
        "templateID": {
          "defaultValue": "392012"
        }
      },
      "homepageHeader": {
        "title": "SLOTS",
        "image": "{assetsPath}/images/arenas/HomePage/slots_jackpots_arena.png",
        "link": "/spielautomaten/"
      }
    },
    "exclusive888Games": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/888exclusive_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/888exclusive_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/888exclusive_arena_banner_mobile.png"
          }
        ]
      },
      "title": "EXCLUSIVE",
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/888exclusive_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES",
        "infoText": "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES"
      },
      "promotionalBanner": {
        "componentID": "495166",
        "templateID": "392012"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "495172",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": "495153",
        "templateID": "392012"
      },
      "homepageHeader": {
        "title": "EXCLUSIVE",
        "image": "{assetsPath}/images/arenas/HomePage/888exclusive_arena.png",
        "link": "/888-exklusive-spiele/"
      },
      "advancedFilters": {
        "categories": [
          { "id": "gameGroups" },
          { "id": "features" },
          { "id": "vendors" }
        ]
      }

    },
    "scratchCards": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/scrach_card_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/scrach_card_arena_banner_tablet.png"

          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/scrach_card_arena_banner_mobile.png"
          }
        ]
      },
      "title": "INFO_TITLE_ARENA_SCRATCH_CARDS",
      "filters": [
      ],
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/scratch_cards_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_SCRATCH_CARDS",
        "infoText": "INFO_TEXT_ARENA_SCRATCH_CARDS"
      },
      "promotionalBanner": {
        "display": true,
        "componentID": "497245",
        "templateID": "392012"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "497534",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": {
          "defaultValue": "497254"
        },
        "templateID": {
          "defaultValue": "392012"
        }
      },
      "homepageHeader": {
        "title": "SCRATCH_CARDS",
        "image": "{assetsPath}/images/arenas/HomePage/scratch_cards_arena_icon.png",
        "link": "/scratch-cards/"
      }
    },
    "newGames": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/new_games_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/new_games_arena_banner_tablet.png"

          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/new_games_arena_banner_mobile.png"
          }
        ]
      },
      "title": {
        "defaultValue": "INFO_TITLE_ARENA_NEW_GAMES",
        "statements": []
      },
      "filters": [
      ],
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/new_games_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_NEW_GAMES",
        "infoText": "INFO_TEXT_ARENA_NEW_GAMES"
      },
      "promotionalBanner": {
        "display": false,
        "componentID": "524265",
        "templateID": "392012"
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": "524267",
        "templateID": "392012"
      },
      "homepageHeader": {
        "title": "NEW_GAMES",
        "image": "{assetsPath}/images/arenas/HomePage/new_games_arena.png",
        "link": "/new-games/"
      }
    }
  },
  "homePage": {
    "topBanner": {
      "componentID": {
        "defaultValue": "494495"
      },
      "templateID": {
        "defaultValue": "392012"
      },
      "miniTopBannerComponentID": "561132"
    },
    "headerArenasOrder": [ "slots", "newGames", "exclusive888Games" ],
    "promotionalBanner": {
      "displayPlace": {
        "defaultValue": 4
      },
      "componentID": {
        "defaultValue": "561154"
      },
      "templateID": {
        "defaultValue": "392012"
      }
    },
    "seoSection": {
      "display": {
        "defaultValue": true,
        "statements": [
          {
            "condition": "OR",
            "rules": [
              {
                "id": "isEmbeddedHybrid",
                "operator": "equal",
                "value": true
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": false
          }
        ]
      },
      "componentID": {
        "defaultValue": "495135"
      },
      "templateID": {
        "defaultValue": "392012"
      }
    }
  },
  "historyPage": {
    "topImage": {
      "defaultValue": "{assetsPath}/images/history_bg_title.png",
      "statements": [
      ]
    },
    "title": {
      "defaultValue": "GAMING_HISTORY",
      "statements": []
    }
  },
  "generalSettings": {
    "brandName": "888Slots",
    "assetsPath": "{assetsPath}",
    "showBreadcrumbs": true,
    "googleOptimize": {
      "isEnabled": false
    },
    "logoURL": {
      "defaultValue": "{assetsPath}/images/888casinologo.png",
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 0
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/888casinologo.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 0
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/888casinologo.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 1
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/reg-vip/vip-regular-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 1
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/reg-vip/vip-regular-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 2
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/gold-vip/vip-gold-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 2
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/gold-vip/vip-gold-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 3
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/diamond-vip/vip-diamond-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 3
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/diamond-vip/vip-diamond-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 5
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/platinum-vip/vip-platinum-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 5
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/platinum-vip/vip-platinum-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 0
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/888casinologo.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 0
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/888casinologo.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 1
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/reg-vip/vip-regular-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 1
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/reg-vip/vip-regular-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 2
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/gold-vip/vip-gold-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 2
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/gold-vip/vip-gold-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 3
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/diamond-vip/vip-diamond-logo-pc.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 3
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/diamond-vip/vip-diamond-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 5
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "mobile"
            }
          ],
          "value": "{assetsPath}/images/logos/platinum-vip/vip-platinum-logo-mobile.png"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 5
            },
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            },
            {
              "id": "deviceType",
              "operator": "equal",
              "value": "pc"
            }
          ],
          "value": "{assetsPath}/images/logos/platinum-vip/vip-platinum-logo-pc.png"
        }
      ]
    },
    "avatarUrl": {
      "drawer": {
        "defaultValue": {
          "regular": "{assetsPath}/images/avatars/reg/pre-login-reg.png",
          "hover": "{assetsPath}/images/avatars/reg/pre-login-reg.png",
          "pressed": "{assetsPath}/images/avatars/reg/pre-login-reg.png"
        },
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 0
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/user-menu-box-icon.png",
              "hover": "{assetsPath}/images/user-menu-box-icon.png",
              "pressed": "{assetsPath}/images/user-menu-box-icon.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 1
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg-vip/my-account-vip-reg.png",
              "hover": "{assetsPath}/images/avatars/reg-vip/my-account-vip-reg.png",
              "pressed": "{assetsPath}/images/avatars/reg-vip/my-account-vip-reg.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 2
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/gold-vip/my-account-gold-vip.png",
              "hover": "{assetsPath}/images/avatars/gold-vip/my-account-gold-vip.png",
              "pressed": "{assetsPath}/images/avatars/gold-vip/my-account-gold-vip.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 3
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/diamond-vip/my-account-diamond-vip.png",
              "hover": "{assetsPath}/images/avatars/diamond-vip/my-account-diamond-vip.png",
              "pressed": "{assetsPath}/images/avatars/diamond-vip/my-account-diamond-vip.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 5
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/platinum-vip/my-account-vip-platinum.png",
              "hover": "{assetsPath}/images/avatars/platinum-vip/my-account-vip-platinum.png",
              "pressed": "{assetsPath}/images/avatars/platinum-vip/my-account-vip-platinum.png"
            }
          }
        ]
      },
      "sideMenu": {
        "defaultValue": {
          "regular": "{assetsPath}/images/avatars/reg/pre-login-reg.png",
          "hover": "{assetsPath}/images/avatars/reg/pre-login-hover.png",
          "pressed": "{assetsPath}/images/avatars/reg/pre-login-pressed.png"
        },
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 1
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-icon-regular.png",
              "hover": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-icon-hover.png",
              "pressed": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-icon-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 2
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 3
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 5
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 0
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg/post-login-reg.png",
              "hover": "{assetsPath}/images/avatars/reg/post-login-hover.png",
              "pressed": "{assetsPath}/images/avatars/reg/post-login-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 1
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-selected-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 2
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-selected-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 3
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-selected-pressed.png"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 5
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-regular.png",
              "hover": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-hover.png",
              "pressed": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-selected-pressed.png"
            }
          }
        ]
      }
    },
    "fallbackCMSComponentsPath": "{assetsPath}/fallbackCMSComponent/{fileName}.html",
    "gamesSettings": {
      "gamesPreviewDefaultImages": "{assetsPath}/games/preview_default_images/default_game_strip_{arena-category}.png",
      "gameBadgePath": "{assetsPath}/images/badges/",
      "homePageArenaDefaultPlaceHolder": "{assetsPath}/images/arenas/Homepage/default_arena.png",
      "liveArenaDefaultPlaceHolder": "{assetsPath}/images/arenas/LiveArenas/default_live_arena.png"
    },
    "sideMenuDarkLogo": true,
    "gamesPreviewConfig": {
      "shouldDisplayJackpot": false,
      "disabledFeatures": [ "hasJackpot" ]
    },
    "filters": {
      "advancedFilters": {
        "preferredVendorFilters": [
          "vendor_888",
          "vendor_playngo",
          "vendor_redtiger",
          "vendor_pragmatic",
          "vendor_gamomat",
          "vendor_netent",
          "vendor_merkur",
          "vendor_playtech",
          "vendor_gamesglobal",
          "vendor_blueprint",
          "vendor_thunderkick",
          "vendor_amatic",
          "vendor_lnw",
          "vendor_yggdrasil",
          "vendor_inspired",
          "vendor_isoftbet",
          "vendor_elk",
          "vendor_skywind",
          "vendor_greentube",
          "vendor_redrake"
        ],
        "preferredThemeFilters": [
          "theme_egyptian",
          "theme_fish",
          "theme_fantasy_and_folklore",
          "theme_wildlife",
          "theme_classic_style",
          "theme_greek_mythology",
          "theme_adventure",
          "theme_diamonds_and_gems",
          "theme_arabic",
          "theme_comics_and_cartoons",
          "theme_fruit_and_candy",
          "theme_asian",
          "theme_irish",
          "theme_seasonal",
          "theme_space_and_sci-fi"
        ]
      }
    }
  },
  "safezone": {
    "enabled": false
  },
  "registrationOffer": {
    "display": {
      "defaultValue": false,
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            }
          ],
          "value": true
        }
      ]
    },
    "componentID": "543323",
    "templateID": "392012"
  },
  "SDK": {
    "WebPush": {
      "enabled": true,
      "prodSettings": {
        "defaultIcon": "https://c00120-dl.urbanairship.com/binary/public/rmsOEtEaQQ65bKvGsx5erg/7aeaa95a-afa7-4f9e-8983-b0864c9ded50",
        "defaultTitle": "888slots",
        "defaultActionURL": "https://www.888slots.de",
        "appKey": "rmsOEtEaQQ65bKvGsx5erg",
        "token": "MTpybXNPRXRFYVFRNjViS3ZHc3g1ZXJnOjBiYXZNOTFUd0p5Y3U3MzRvelBBNmtJd2tsMmszNDZUaVdZTU9TcFpJaDQ",
        "vapidPublicKey": "BIpI1YnfZ7yzTVkrPKkT33p96Prykjt7a0DpsYiKV8WGKPocuEyO_k6VFVsVVmeXwXHHaLJTNprqE_b1lEAmVfU="
      },
      "testSettings": {
        "defaultIcon": "https://c00120-dl.urbanairship.com/binary/public/WyOI2VobSEm0pxXPaxqdGg/b53e83ef-a24a-4949-8049-bfe018f0a393",
        "defaultTitle": "888slots",
        "defaultActionURL": "https://www.888slots.de",
        "appKey": "WyOI2VobSEm0pxXPaxqdGg",
        "token": "MTpXeU9JMlZvYlNFbTBweFhQYXhxZEdnOlRSSVV1VmVJSWtoQ3ZPUGoyR1o4U19xLWY1REpBaGd3d3lFQUxxSXlHM2M",
        "vapidPublicKey": "BOm2KBz1TWwjoe0-w_PQPsWTPhMqKcAxYbn42PDwRHEG_QDJ80961kOUrMAVa3L_acvDpEvlHZ-6FKXTa9qiUzI="
      }
    },
    "Skin": {
      "responsibleGamblingLink": "https://www.888.de/sicherheit-datenschutz/verantwortungsbewusstes-spielen/"
    },
    "NetEnt": {
      "staticServerUrlTemplate": {
        "defaultValue": "https://{casinoid}-staticde-test.casinomodule.com",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "env",
                "operator": "equal",
                "value": "prod"
              }
            ],
            "value": "https://{casinoid}-staticde.casinomodule.com"
          }
        ]
      }
    }
  }
}
